import React from "react";
import HeroSection from "../containers/Services/HeroSection";
// import OurServices from "../containers/Services/OurServices";
import OurServices from "../containers/Services/Servicechoose";
import AllServices from "../containers/Services/AllServices"
import GlobalReach from "../containers/Services/GlobalReach";
import Partner from "../containers/Services/LastSection";

const Services = () => {
  return (
    <>
      <HeroSection />
      <GlobalReach />
      <OurServices />
      <AllServices/>
      <Partner />
    </>
  );
};

export default Services;
